import EfficiencyClassBars from './efficiency-class-bars'

export const AmuiEfficiencyClassBars = EfficiencyClassBars

export default Vue =>
  Vue.component(EfficiencyClassBars.name, EfficiencyClassBars)
